<template>
    <div class="purchase-credits-page position-relative">
        <div class="title position-relative w-fit px-2">
            <h1> Choose your Credit Package </h1>
            <div class="title-underline" />
        </div>

        <p class="text-small">By clicking "Buy now", you agree to our <a href="/agent-terms-and-conditions"
                target="_blank">Terms and
                Conditions</a>.</p>

        <div class="purchase-credits-page-cards">
            <div v-for="plan in pageState.plans" class="card-item" :class="{ 'popular': plan.is_popular }"
                :key="`purchase-credits-card-${plan.name}`">
                <div class="card-item-header">
                    {{ plan.name }}

                    <div class="popular-tag" v-if="plan.is_popular">
                        Most Popular
                    </div>
                </div>
                <div class="card-item-price">
                    {{ plan.price_formatted }}
                </div>
                <div v-for="feature in plan.features" class="card-item-feature" :key="`feature-${feature}`">
                    {{ feature }}
                </div>
                <p class="card-item-footer-note">
                    Credit on account does not expire and is non-refundable. All prices are excluding VAT.
                </p>
                <button class="btn btn--xs buy-btn" @click.prevent="addCredits(plan.price)" :disabled="isLoading">
                    Buy now
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { redirectTo, urlParamsToJson } from '@helpers/url-handler';

export default {
    data() {
        return {
            isLoading: false,
        };
    },
    computed: {
        ...mapState(['pageState']),
    },
    methods: {
        redirectTo,
        getQueryParams() {
            return urlParamsToJson({
                redirectSuccessTo: {
                    urlParamName: 'redirectSuccessTo',
                    defaultValue: '',
                },
            });
        },
        addCredits(amount) {
            this.isLoading = true;
            this.axios.post('/api/subscriptions/add-credits', { amount })
                .then(() => {
                    window.showToastSuccess('Credits added successfully');
                    const queryParams = this.getQueryParams();
                    if (queryParams.redirectSuccessTo) {
                        this.redirectTo(`/${queryParams.redirectSuccessTo}`);
                    }
                }).catch(() => {
                    window.showToastError('Could not add credits. Please try again later');
                }).finally(() => {
                    this.isLoading = false;
                });
        },
    },
};
</script>
